import React from 'react';
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import { createRoot } from 'react-dom/client';
import 'react-toastify/dist/ReactToastify.css';
import { SessionProvider } from "./context/SessionContext";
import { ShoppingCartProvider } from "context/ShoppingCartContext";

const root = document.getElementById('root');
const rootElement = (
  <React.StrictMode>
    <SessionProvider>
      <ShoppingCartProvider>
        <BrowserRouter basename='/sees'>
          <App />
        </BrowserRouter>
      </ShoppingCartProvider>
    </SessionProvider>
  </React.StrictMode>
);

const container = createRoot(root);
container.render(rootElement);
